import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

import {
  CatalogNameExtension,
  catalogTeamNameValidation,
} from './fields/CatalogNamePicker';
import { GenericValueInputPicker } from './fields/GenericValueInputPicker';
import { GithubTeamPickerExtension } from './fields/GithubTeamPicker';
import {
  RepoNamePicker,
  RepoNamePickerFieldSchema,
  repoNamePickerValidation,
} from './fields/RepoNamePicker';
import { UrlInput, validateUrlInput } from './fields/UrlInput';

// `name` is the value used as `ui:field` in the template YAML.
const fields: Array<{
  id: string;
  name: string;
  component: any;
  validation?: any;
  schema?: any;
}> = [
  {
    id: 'generic-value-input-picker',
    name: 'GenericValueInputPicker',
    component: GenericValueInputPicker,
  },
  {
    id: 'url-input',
    name: 'UrlInput',
    component: UrlInput,
    validation: validateUrlInput,
  },
  {
    id: 'catalog-name-picker',
    name: 'CatalogNamePicker',
    component: CatalogNameExtension,
    validation: catalogTeamNameValidation,
  },
  {
    id: 'github-team-picker',
    name: 'GithubTeamPicker',
    component: GithubTeamPickerExtension,
  },
  {
    id: 'repo-name-picker',
    name: 'RepoNamePicker',
    component: RepoNamePicker,
    validation: repoNamePickerValidation,
    schema: RepoNamePickerFieldSchema,
  },
];

/**
 * Registers the custom scaffolder form-field extensions shared by the catalog,
 * API, TechDocs and GitHub software templates. Attaches to the scaffolder
 * page's `formFields` input via `pluginId: 'scaffolder'`.
 */
export const scaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: fields.map(({ id, name, component, validation, schema }) =>
    FormFieldBlueprint.make({
      name: id,
      params: {
        field: async () =>
          createFormField({ name, component, validation, schema }),
      },
    }),
  ),
});
